export enum ConfirmModalType {
    DeleteTiers = 'confirm-delete-tiers',
    ApplyFeeChange = 'confirm-apply-fee-change'
}
